import {
  type NavigatorAction,
  navigatorActions,
  type NavigatorState
} from '../context';

export const navigatorReducer = (
  state: NavigatorState,
  action: NavigatorAction
) => {
  let updatedState = state;
  switch (action.type) {
    case navigatorActions.SET_BACK_NAVIGATION:
      updatedState = { ...state, backNavigation: action.payload };
      break;
    case navigatorActions.SET_LOGO_CLICKED:
      updatedState = { ...state, logoClicked: action.payload };
      break;
    case navigatorActions.SET_IS_ONLINE:
      updatedState = { ...state, isOnline: action.payload };
      break;
    default:
      return state;
  }
  return updatedState;
};
